import * as React from 'react';
import { forwardRef, memo } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';

import LocationAutocompleteComponent from './LocationAutocomplete';
import { Props } from './LocationAutocomplete';
import { useGraphQLClient } from '../../graphql-client';

const LocationAutocomplete: React.FunctionComponent<Props> = memo(
	forwardRef<HTMLDivElement, Props>((props, ref) => {
		const client = useGraphQLClient();

		return (
			<ApolloProvider client={client}>
				<LocationAutocompleteComponent ref={ref} {...props} />
			</ApolloProvider>
		);
	}),
	(prevProps, nextProps) => {
		for (const prop in nextProps) {
			// Dirty hacks.
			if (nextProps.hasOwnProperty(prop) && prop !== 'inputRenderer') {
				if (nextProps[prop] !== prevProps[prop]) {
					return false;
				}
			}
		}

		return true;
	}
);

export default LocationAutocomplete;
